<template>
  <div>
    <div class="mb-3 pb-3 border-bottom">
      <strong v-text="$lang.reportCharacterLabel" />
    </div>
    <ChartLineProgress :data="azmoonExecutePersonData" />
  </div>
</template>

<script>
import ChartLineProgress from "./../votes1/chartLineProgress";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    ChartLineProgress,
  },
  props: {
    code: {
      type: [String, Number],
    },
  },
  data() {
    return {
      azmoonExecutePersonData: [],
    };
  },

  created() {
    this.getAzmoonExecutePersonResult();
  },
  methods: {
    pathOr,
    generateApiUrl,
    async getAzmoonExecutePersonResult() {
      // check requirement
      if (!this.code) {
        return false;
      }

      try {
        this.$emit("loading", true);
        const url = generateApiUrl(
          ["report", "report_person_result"],
          [this.code]
        );
        const response = await this.$httpService.get(url);
        this.azmoonExecutePersonData = [
          ...pathOr([], ["data", "data", "result"], response),
        ];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("loading", false);
      }
    },
  },
};
</script>